<template>
  <v-select
    v-model="localValue"
    :items="localAttributions"
    item-value="value"
    hide-no-data
    :label="$t('attribution')"
    required
    :disabled="disabled"
    :error-messages="errors"
    :menu-props="{ maxWidth: '316px' }"
  >
    <template v-slot:selection="{ item }">
      <v-list-item-content>
        {{ $t(`attributions.${item.name}`) }}
      </v-list-item-content>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          {{ $t(`attributions.${item.name}`) }}
        </v-list-item-title>
        <v-list-item-subtitle class="grey--text">
          {{ $t(`descriptions.${item.name.toLowerCase()}`) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { CustomFieldMixin } from '@argon/app/mixins'
import { NAMESPACE as ATTRIBUTION_NAMESPACE } from '../attributions/store'

export default {
  name: 'AttributionField',
  mixins: [CustomFieldMixin],
  props: {
    provided: Array
  },
  methods: {
    ...mapActions(ATTRIBUTION_NAMESPACE, ['listAttributions'])
  },
  computed: {
    ...mapState(ATTRIBUTION_NAMESPACE, ['attributions']),
    localAttributions() {
      return this.provided || this.attributions
    }
  },
  created() {
    let getAttributions = !this.provided && this.attributions.length === 0
    if (getAttributions) {
      this.listAttributions().catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-list__tile {
  height: 72px !important;
  align-items: top !important;
}

.v-list__tile__sub-title {
  white-space: normal !important;
}
</style>

<i18n>
{
  "en": {
    "attribution": "@:labels.attribution",
    "descriptions": {
      "collaborator": "They collaborate on attributed resources but can't create or delete.",
      "manager": "They manage attributed resources and have full access.",
      "member": "They collaborate on attributed resources but can't delete.",
      "observator": "They see attributed resources but can't collaborate.",
      "owner": "They own attributed resources and have full access."
    }
  },
  "fr": {
    "attribution": "@:labels.attribution",
    "descriptions": {
      "collaborator": "Ils collaborent sur des ressources attribuées mais ne peuvent ni créer ni supprimer.",
      "manager": "Ils gèrent des ressources attribuées et ont un accès complet.",
      "member": "Ils collaborent sur des ressources attribuées mais ne peuvent pas supprimer.",
      "observator": "Ils voient des ressources attribuées mais ne peuvent pas collaborer.",
      "owner": "Ils possèdent des ressources attribuées et ont un accès complet."
    }
  }
}
</i18n>
